<template>
  <div>
    <PFRow :label="$pgettext('event_wizard.gallery.modal.label','Name')" size="12x12">
      <CInput v-model="form.name" :placeholder="$pgettext('event_wizard.gallery.modal.placeholder','Gallery name')"
              @input="onChange"/>
    </PFRow>
    <PFRow :label="$pgettext('event_wizard.gallery.modal.label','Parent')" size="12x12"
           v-if="nestedGalleries.length">
      <multiselect
          v-model="selected"
          :placeholder="$pgettext('event_wizard.gallery.modal.placeholder','Select parent gallery')"
          label="name"
          track-by="id"
          :options="nestedGalleries"
          @input="onGallerySet"
      >
        <template #option="props">
          <div class="option__desc">
            <span>{{ props.option.name }}</span>
          </div>
        </template>
      </multiselect>
    </PFRow>
  </div>
</template>

<script>

import PFRow from "@/domain/core/components/PFRow.vue";
import {mapGetters} from "vuex";
import Multiselect from "vue-multiselect";

export default {
  name: "GalleryCustom",
  components: {Multiselect, PFRow},
  emits: ['save'],
  data() {
    return {
      form: {
        name: null,
        parent_gallery: null,
      },
      selected: null,
    }
  },
  computed: {
    ...mapGetters('eventGallery', [
      'galleries',
    ]),
    nestedGalleries() {
      if (!this.galleries) return []

      // Flatten the gallery hierarchy with path notation
      const result = []

      // Recursive function to process galleries and their sub-galleries
      const processGallery = (gallery, path = '') => {
        // Create the display name with path notation
        const displayName = path ? `${path} > ${gallery.name}` : gallery.name

        // Add the gallery to the result
        result.push({
          id: gallery.id,
          name: displayName,
          originalName: gallery.name
        })

        // Process sub-galleries if they exist
        if (gallery.sub && gallery.sub.length) {
          gallery.sub.forEach(subGallery => {
            processGallery(subGallery, displayName)
          })
        }
      }

      // Process each top-level gallery
      this.galleries.forEach(gallery => {
        processGallery(gallery)
      })

      return result
    },
  },
  mounted() {
    this.onChange()
  },
  methods: {
    onChange() {
      this.$emit('save', this.form);
    },
    onGallerySet(value) {
      if (!value) {
        this.form.parent_gallery = null
      } else {
        this.form.parent_gallery = value.id
      }
      this.onChange()
    }
  }
}
</script>
